import { render } from "./gaji-print.vue?vue&type=template&id=745c8c08&scoped=true"
import script from "./gaji-print.vue?vue&type=script&lang=js"
export * from "./gaji-print.vue?vue&type=script&lang=js"

import "./gaji-print.vue?vue&type=style&index=0&id=745c8c08&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-745c8c08"]])

export default __exports__